import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';
import { ResponsiveModalBackdropService } from './responsive-modal-backdrop.service';

/**
 * Renders a single fixed backdrop shared across all open desktop
 * `app-responsive-modal` instances. Visibility is driven by
 * `ResponsiveModalBackdropService.active()` so chained modals keep the
 * backdrop mounted and avoid the fade-out/fade-in flicker.
 */
@Component({
  selector: 'app-responsive-modal-backdrop',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (backdropService.active()) {
      <div class="responsive-modal-backdrop" [@backdrop] aria-hidden="true"></div>
    }
  `,
  styles: [
    `
      .responsive-modal-backdrop {
        background-color: rgba(0, 0, 0, 0.32);
        inset: 0;
        pointer-events: none;
        position: fixed;
        z-index: 19999;
      }
    `,
  ],
  animations: [
    trigger('backdrop', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('180ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 1 })),
      ]),
      transition(':leave', [animate('180ms cubic-bezier(0.4, 0, 0.2, 1)', style({ opacity: 0 }))]),
    ]),
  ],
})
export class ResponsiveModalBackdropComponent {
  readonly backdropService = inject(ResponsiveModalBackdropService);
}
